import { defaultAnimateLayoutChanges, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Collapse } from 'antd';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import { PanelHeader } from 'app/components/layout/PanelHeader/PanelHeader';

import 'styles/layout/Sortable/Collapse/sortable-panel.scss';

import { SortableHandleComponent } from '../SortableHandle';

import { PanelMenu } from './PanelMenu';

const { Panel } = Collapse;

export const SortablePanel = ({
  id,
  title,
  onRemove,
  card,
  children,
  menuDisplayed = true,
  className = '',
  ...props
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
  } = useSortable({
    id,
    animateLayoutChanges: (args) =>
      defaultAnimateLayoutChanges({ ...args, wasDragging: true }),
  });

  const setPanelRef = useCallback(
    (node) => {
      setActivatorNodeRef(node);
      setNodeRef(node ? node.closest('.ant-collapse-item') : null);
    },
    [setActivatorNodeRef, setNodeRef]
  );

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <Panel
      {...props}
      style={style}
      key={props.key}
      className={`panel sortable-panel ${className}`}
      header={
        <PanelHeader
          name={title}
          actions={[
            <SortableHandleComponent
              key="handle"
              ref={setPanelRef}
              {...attributes}
              {...listeners}
            />,
            menuDisplayed && <PanelMenu key="menu" onRemove={onRemove} />,
          ]}
          card={card}
        />
      }
      forceRender
    >
      {children}
    </Panel>
  );
};

SortablePanel.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  title: PropTypes.string.isRequired,
  card: PropTypes.bool,
  onRemove: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  menuDisplayed: PropTypes.bool,
};
